import Block from '../../common.blocks/block'

export default class ImageZoom extends Block {
	static title = 'image-zoom'

	constructor($el) {
		super($el)

		import(/* webpackChunkName: 'drift-zoom' */ 'drift-zoom')
			.then(({ default: Drift }) => {
				new Drift(this.$el.get(0), {
					paneContainer: this.$el.parent().get(0),
					onShow: () => {
						this.$el.css('opacity', 0)
					},
					onHide: () => {
						this.$el.css('opacity', 1)
					},
					zoomFactor: 3,
				})
			})
			.catch((error) => {
				// eslint-disable-next-line no-console
				console.error('image-zoom: failed to load drift-zoom', error)
			})
	}
}
